import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;

export const AddArticle = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Article/Save`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //Get Article & Discussion
  export const getArticle = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Articles`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response); 
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //Get Article Likelist
    export const getArticleLikelist = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Article/Likelist`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response); 
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

// Delete Article & Discussions

export async function DeleteArticle(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Article/Delete`,params,{
    headers: await getHeaders(),
    body: JSON.stringify(params),
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
 
}

export const LikeCommentArticle = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Article/React`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const changeArchivedFeature = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Article/MarkFeatureArchive`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}